import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectUser } from "@/store/auth/auth.slice";
import { useThunkSelector } from "@/store/hooks";

import { TAB_STATUSES } from "../constants";
import { useUrlParams } from "./useUrlParams";
import { serverEvents } from "../services/serverEvents";
import { setUploadProgress } from "../store/actions";
import { currentExperienceSelector, currentPropertySelector } from "../store/selectors";

function eventListener(event, fn) {
  document.addEventListener(event, fn);

  return () => document.removeEventListener(event, fn);
}

export function useEventListeners(props = {}) {
  const dispatch = useDispatch();
  const { tabStatus } = useUrlParams();
  const user = useThunkSelector(selectUser);
  const { property } = useSelector(currentPropertySelector);
  const { experience } = useSelector(currentExperienceSelector);
  const { id: userId = null } = user;

  useEffect(() => {
    const { entities = [] } = props;

    if (userId || (tabStatus === TAB_STATUSES.PUBLIC && property.id && experience.id)) {
      // begin listening for server events
      return serverEvents(
        // websocket path
        import.meta.env.VITE_APP_WS_URL,
        entities,
        { userId, propertyId: property.id, experienceId: experience.id },
      );
    }
  }, [tabStatus, userId, property.id, experience.id]);

  useEffect(() => {
    return eventListener("WS_MESSAGE", ({ detail: { payload } }) => {
      payload.instances = payload.instances ?? [];
      payload.options = payload.options ?? {};

      document.dispatchEvent(new CustomEvent(payload.entity, { detail: payload }));
    });
  }, [property.id, experience.id]);

  useEffect(() => {
    return eventListener("UPLOAD_PROGRESS", ({ detail: { path, value } }) => {
      if (path) {
        dispatch(setUploadProgress(path, value));
      }
    });
  }, [property.id]);
}
